import { ChevronUp } from "react-feather";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import React from "react";

interface FoldInButtonProps {
onClick: () => void;
className?: string;
}

export default function FoldInButton({ onClick, className }: FoldInButtonProps) {
const { t } = useTranslation("liveblog");

return (
    <div className={classNames("tik4-fold-in", className)}>
        <button className="tik4-fold-in__link tik4-link" onClick={onClick}>
            <ChevronUp className="tik4-icon tik4-icon--mr"/>
            <span className="tik4-fold-in__link__text">
                {t('liveblog.event.fold_in.button')}
            </span>
        </button>
    </div>
);
}